import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { map } from "rxjs/operators";
import { PageModel } from "@app/models/page.model";
import { Supply } from "@app/models/supply.model";
import { SupplyAdapter } from "@app/adapters/supply.adapter";

@Injectable({ providedIn: "root" })
export class SupplyApiService {

  constructor(private readonly adapter: SupplyAdapter, private readonly http: HttpClient) {
  }

  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1`;

  getSupply(supplyId: string): Observable<Supply> {
    return this.http.get<Supply>(`${this.baseUrl}/supplies?supplyId=${supplyId}`).pipe(
      map(data => this.adapter.adapt(data)));
  }

  getSuppliesAll(params: HttpParams): Observable<PageModel<Supply>> {
    return this.http.get<PageModel<Supply>>(`${this.baseUrl}/supplies/all`, { params }).pipe(map(data => new PageModel<Supply>({
      totalPages: data.totalPages, totalElements: data.totalElements, content: this.adapter.adaptArray(data.content),
    })));
  }

}
